module.exports = __webpack_public_path__ + "assets/88b190327fd4933a3267f1aa7b4b5eb4.png";